jQuery(document).ready(function ($) {
    var elem = $('.Acknowledgement-content-title');
    if (elem.children().length == 0) {
        $('.Acknowledgement').addClass('hide');
    }
});
